<h2 mat-dialog-title>Problemy z połączeniem</h2>
<mat-dialog-content style="overflow: hidden;" fxLayoutAlign="start start">
Wykryliśmy brak lub wolne połączenie z Internetem. Czy chcesz przejść w tryb offline? 
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-flat-button mat-dialog-close>NIE</button>
    <button mat-flat-button (click)="switchToOffline()">TAK</button>
</mat-dialog-actions>